import React, {useContext} from 'react';
import {GlobalContext} from '../../../utilities/GlobalContext';
import areYouReadyStyle from './style';
import runner from '../../../images/Home/runner.png';
import gymGuy from '../../../images/Home/gymGuy.png';

export default function AreYouReady() {
	let style = areYouReadyStyle();
	let isMobile = useContext(GlobalContext).isMobile;

	function DSKArangment() {
		return (
			<>
				<div className={style.dskAYRLeftColClasses()} style={style.dskAYRLeftColStyle()}>
					<h1 style={style.mainTitleText()}>Are you ready?</h1>
					<p style={style.genericTextStyle()}>Are you tired of being unable to carry yourself?</p>
					<p style={style.genericTextStyle()}>
						Are you tired of looking at yourself in the mirror knowing you deserve better?
					</p>
					<p style={style.genericTextStyle()}>
						Do you feel that you are a burden when you’re with other people or on a team?{' '}
					</p>
					<p style={style.genericTextStyle()}>More importantly, do you feel like a burden about yourself?</p>
					<p style={style.genericTextStyle()}>
						Do you question if it is even possible to change yourself for the better?
					</p>
					<h1 style={style.seceondMainTitleText()}>The answer will always be “YES!!! I can change!”</h1>
				</div>
				<div className={style.dskAYRRightColClasses()} style={style.dskAYRRightColStyle()}>
					<img style={style.imageStyle({order: 1})} src={runner} />
					<img style={style.imageStyle({order: 2})} src={gymGuy} />
				</div>
			</>
		);
	}

	function MOBArangment() {
		return (
			<>
				<h1 style={style.mainTitleText()}>Are you ready?</h1>
				<p style={style.genericTextStyle(true)}>Are you tired of being unable to carry yourself?</p>
				<img style={style.imageStyle({order: 1})} src={runner} />
				<p
					style={{
						...style.genericTextStyle(true),
						...{
							marginTop: '5rem',
						},
					}}
				>
					Are you tired of looking at yourself in the mirror knowing you deserve better?
				</p>
				<p style={style.genericTextStyle()}>
					Do you feel that you are a burden when you’re with other people or on a team?{' '}
				</p>
				<p style={style.genericTextStyle(true)}>More importantly, do you feel like a burden about yourself?</p>
				<p style={style.genericTextStyle()}>
					Do you question if it is even possible to change yourself for the better?
				</p>
				<img style={style.imageStyle({order: 2})} src={gymGuy} />
				<p
					style={{
						...style.genericTextStyle(true),
						...{
							marginTop: '5rem',
						},
					}}
				>
					The answer will always be “YES!!! I can change!”
				</p>
			</>
		);
	}
	return <div style={style.AYRContainerStyle()}>{isMobile ? MOBArangment() : DSKArangment()}</div>;
}
